module.exports = __webpack_public_path__ + "img/pharmaphie.560ee7ac.png";